module.exports = __webpack_public_path__ + "img/cpzz0@2x.5711f4ec.png";